export const FULFILLMENT_FILTER_OPTIONS = [
    { value: "", label: "Tous" },
    { value: "PICKUP", label: "Retrait en magasin" },
    { value: "DELIVERY", label: "Livraison à l'adresse" }
];

export const EMPTY_ORDER_FILTERS = {
    search: "",
    customer: "",
    fulfillmentType: "",
    priceMin: "",
    priceMax: "",
    dateFrom: "",
    dateTo: ""
};

export function buildOrderSearchQuery(filters) {
    const params = new URLSearchParams();

    if (filters.search?.trim()) {
        params.set("search", filters.search.trim());
    }
    if (filters.customer?.trim()) {
        params.set("customer", filters.customer.trim());
    }
    if (filters.fulfillmentType) {
        params.set("fulfillmentType", filters.fulfillmentType);
    }
    if (filters.priceMin !== "" && filters.priceMin != null) {
        params.set("priceMin", String(filters.priceMin));
    }
    if (filters.priceMax !== "" && filters.priceMax != null) {
        params.set("priceMax", String(filters.priceMax));
    }
    if (filters.dateFrom) {
        params.set("dateFrom", filters.dateFrom);
    }
    if (filters.dateTo) {
        params.set("dateTo", filters.dateTo);
    }

    return params;
}

export function orderFiltersWithCustomer(customer) {
    const trimmedCustomer = customer?.trim() || "";
    if (!trimmedCustomer) {
        return EMPTY_ORDER_FILTERS;
    }
    return { ...EMPTY_ORDER_FILTERS, customer: trimmedCustomer };
}
